import Box from '@material-ui/core/Box';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_DATE_FORMAT_WITH_TIME_24 } from 'globalconfig/constants/static';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { columns } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const FuelComsumptionAddEdit = lazy(() => import(`@/modules/FuelComsumptionAddEdit`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  refillsHistory,
  Styled,
  viewReport,
  callback,
  vehicleList,
  driverList,
  getVehicleListDropDown,
  getDrivers,
  getStateListData,
  addEditFuelData,
  fuelConsumption,
}) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [withCloseIcon, setwithCloseIcon] = useState(true);
  const [backgroundModal, setbackgroundModal] = useState(false);

  const closeModal = () => {
    setOpen(false);
  };

  const clickedModal = () => {
    setOpen(true);
  };

  const modalDataHandler = (data) => {
    getVehicleListDropDown({ apiId: 'getVehicleListDropDown' });
    getDrivers({ apiId: 'getDrivers' });
    getStateListData({
      apiId: 'getStateListData',
      data: { idPub: data.idPub },
    });
  };

  const generateRows = () => {
    return refillsHistory?.map((item) => {
      const result = { ...item };
      result.date = moment(new Date(item.date)).format(UI_DATE_FORMAT_WITH_TIME_24);
      let jurisdictionLocation = ``;
      if (item.jurisdiction == 'Unknown' || !item.jurisdiction) jurisdictionLocation = item.location;
      if (item.jurisdiction == 'Unknown') item.jurisdiction = i18n.t('fuelConsumption.unknown');
      else jurisdictionLocation = `${item.jurisdiction} - ${item.location}`;
      result.jurisdictionLocation = checkServiceProvider('generateRowsJurisdictionLocation', window.$environment?.SERVICE_PROVIDER, false)
        ? jurisdictionLocation
        : item.jurisdiction;
      result.receipt = (
        <a
          onClick={() =>
            viewReport({
              apiId: 'viewReportApi',
              data: item?.id,
            })
          }
          className="viewReport"
          target="_blank"
        >
          {i18n.t('accidents.viewReceipt')}
        </a>
      );
      return result;
    });
  };

  return (
    <>
      <Styled.Wrapper>
        <Styled.TableWrapper>
          <div className="quickFilter"></div>
          <div className="tableWrapper">
            <Table
              type="client"
              title=""
              columns={columns}
              data={generateRows()}
              emptyMessage={i18n.t('common.tableEmptyMessage')}
              defaultSortBy={{ sortBy: 'date', order: 'desc' }}
              itemsPerPage={10}
              i18n={i18n}
              actions={[
                {
                  icon: (row) => {
                    return (
                      <Icon
                        src={mediaUrls?.edit}
                        tooltip={i18n.t('Edit')}
                        onClick={() => {
                          modalDataHandler({
                            idPub: row.idPub,
                          });
                          setbackgroundModal(false);
                          setwithCloseIcon(true);
                          clickedModal();
                        }}
                      />
                    );
                  },
                },
              ]}
            />
          </div>
        </Styled.TableWrapper>
      </Styled.Wrapper>

      {driverList?.length > 0 && vehicleList?.length > 0 && fuelConsumption?.stateListData && (
        <Modal.default
          open={open}
          width="700px"
          setOpen={setOpen}
          data={{
            header: '',
            content: () => {
              return (
                <FuelComsumptionAddEdit
                  currentData={fuelConsumption?.stateListData?.Fuel}
                  saveDocument={addEditFuelData}
                  uploadApi={'fuelAddEditApi'}
                  stateListData={fuelConsumption?.stateListData}
                  driverList={driverList}
                  vehicleList={vehicleList}
                  closeModal={closeModal}
                  callback={callback}
                  parent="FuelComsumptionReport"
                />
              );
            },
          }}
          onCloseModal={closeModal}
          background="black"
          withCloseIcon={withCloseIcon}
          backgroundModal={backgroundModal}
          deletePopup
        />
      )}
    </>
  );
};

Component.propTypes = {
  vehicles: PropTypes.array.isRequired,
};
